<template>
	<div>
		<div id="smsTemDiv">
			<h1>短信模板：</h1>
			<SMSSendComponent v-for=" (item,index) in templateList" :key="index" :smsTemplate="item"
			 @sendSms="showConfirmSend(item)" @tranfromValue="tranfromValue"/>
		</div>
		<a-table  size="small" :columns="columns" :data-source="neighborList" bordered :loading="loading" 
						 rowKey="pId" :pagination="false" :scroll="{y:400}" 
						:row-selection="rowSelectHandler">
						<span slot="theAction" slot-scope="text, record">
						      <a-button size="small" type="link" @click="showChooseCustomer(record)">选择用户</a-button>
						</span>
						<span slot="theChoosedList" slot-scope="text, record">
							共选择
							<span style="font-weight: bold;">{{theChoosedObject[record.pId]?theChoosedObject[record.pId].length:0}}</span>
							个用户
						</span>
		</a-table>
		<a-drawer title="选择用户" :visible="showFlag" width="700" @close="onDrawerClose" :destroyOnClose='true' :maskClosable="false">
			<ChooseCustomers :neighborId="theNeighbor.pId" @onClose="onDrawerClose" @checkChoosedCustomers="checkChoosedCustomers"/>
		</a-drawer>
		<a-modal v-model="showModal" title="提示" @ok="realSendSms" :confirmLoading="confirmLoading"  
						@cancel="onModalClose" :closable="false" :cancelButtonProps="{props: {disabled: confirmLoading} }" centered>
			<a-form-model :rules="rules" ref="addForm" :model="form" >
				<a-form-model-item label="监督密码" prop="password"  :label-col="{ span: 5 }" :wrapper-col="{ span: 18 }">
					<a-input-password  v-model="form.password" :allowClear="true"  placeholder="请输入监督密码"/>
				</a-form-model-item>
			</a-form-model>
			
		</a-modal>
	</div>
</template>

<script>
	const columns = [
		{
			title: '小区',
			dataIndex: 'neighborName',
			ellipsis :true,
			width:240,
			className:'v-cell',
			align:'center',
		},
		{
			title: '地址',
			dataIndex: 'neighborAddr',
			ellipsis :true,
			width:240,
			className:'v-cell',
			align:'center',
		},
		{
			title:'已选择的用户',
			scopedSlots: { customRender: 'theChoosedList' },
			className:'v-cell',
			align:'center',
		},
		{
			title:'操作',
			key: 'pId',
			scopedSlots: { customRender: 'theAction' },
			width:100,
			className:'v-cell',
			align:'center',
		}
	];

	import SMSSendComponent from '../components/SMSSendComponent.vue'
	import ChooseCustomers from '../components/ChooseCustomers.vue'
	export default {
		components:{
			SMSSendComponent,
			ChooseCustomers,
		},
		data(){
			return{
				columns,
				loading:true,
				showFlag:false,
				showModal:false,
				confirmLoading:false,
				templateList:[],
				neighborList:[],
				customerList:[],
				selectedNeighborList:[],
				theNeighbor:{},
				theChoosedObject:{},
				theTemplate:{},
				theSmsPara:[],
				form:{
					password:null,
				},
				rules:{
					password:[{ required: true, message: '请输入监督密码',trigger: 'blur' },]
				}
			}
		},
		methods:{
			quertDataList:function(){
				let url = this.Api.getLastUrl(this.Api.SMS_TEMPLATE_LIST_URL);
				this.Api.fetchPostWithForm(url).then((data)=>{
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.templateList = result;
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					console.log(error);
				});
			},
			queryNeighbors:function(){
				let url = this.Api.getLastUrl(this.Api.NEIGHBOR_DEPART_NEIGHBORS_URL);
				this.Api.fetchPostWithForm(url).then((data)=>{
					this.loading = false;
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.neighborList = result;
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					this.loading = false;
					console.log(error);
				});
			},
			showChooseCustomer:function(item){
				this.theNeighbor = item;
				this.showFlag = true;
			},
			showConfirmSend:function(smsTemplate){
				this.showModal = true;
				this.theTemplate = smsTemplate;
			},
			tranfromValue:function(para){
				this.theSmsPara = para;
			},
			realSendSms:function(){
				this.$refs.addForm.validate(valid => {
					if(valid) {
						if(this.selectedNeighborList.length == 0){
							this.$message.error('请选择小区');
						}else{
							this.doSendSms();
						}
					} else {
						return false;
					}
				});
			},
			doSendSms:function(){
				this.confirmLoading = true;
				let url = this.Api.getLastUrl(this.Api.FAILURE_NOTICE_URL);
				let para = '';
				if(this.theSmsPara.length>0){
					para = this.theSmsPara.join(',');
				}
				let param = {
					templateId:this.theTemplate.cid,
					password:this.form.password,
					neighborIds:this.selectedNeighborList.join(','),
					customerIds:this.getCustomerids(),
					para:para,
				}
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					this.confirmLoading = false;
					this.onModalClose();
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.$message.success('任务已执行');
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					console.log(error);
					this.confirmLoading = false;
					this.onModalClose();
				});
			},
			getCustomerids:function(){
				var result = [];
				for(var i = 0;i<this.selectedNeighborList.length;i++){
					let neighborId = this.selectedNeighborList[i];
					let tempArray = this.theChoosedObject[neighborId];
					if(tempArray !=null && tempArray.length>0){
						for(var j =0;j<tempArray.length;j++){
							let obj = tempArray[j];
							result.push(obj.pId);
						}
					}
				}
				if(result.length>0){
					return result.join(',');
				}else{
					return '';
				}
			},
			onDrawerClose:function(){
				this.showFlag = false;
			},
			onModalClose:function(){
				this.showModal = false;
				this.$refs.addForm.resetFields();
			},
			checkChoosedCustomers:function(result){
				let neighborId = result[0];
				let customers = result[1];
				//小区id作为key，选择的用户作为value(覆盖)
				this.theChoosedObject[neighborId] = customers;
				if(this.selectedNeighborList.indexOf(neighborId) == -1){
					this.selectedNeighborList.push(neighborId);
				}
			}
		},
		created(){
			this.quertDataList();
			this.queryNeighbors();
		},
		computed:{
			rowSelectHandler:function(){
				return {
					selectedRowKeys:this.selectedNeighborList,
					onChange: (selectedRowKeys, selectedRows) => {
						this.selectedNeighborList = selectedRowKeys;
					},
				}
			}
		}
	}
</script>

<style>
	h1{
			color: red;
			font-size: 1.5rem;
			padding-left: 1.25rem;
	}
	#smsTemDiv{
		display: flex;
		flex-direction:column;
		justify-content: center;
		margin-bottom: 1rem;
	}
</style>
